import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "../CSS/AgentRegister.css";
import logo from "../../assets/icone.png";

const Create_orgainzation_account = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();

    const handleNavigation = (destination) => {
     
  
   
  
      navigate(`/${destination}`);
    };
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full name is required.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email address is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!formData.password) {
      newErrors.password = "Password is required.";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword =
        "Please confirm your password.";
    } else if (
      formData.password !== formData.confirmPassword
    ) {
      newErrors.confirmPassword =
        "Passwords do not match.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      

    
        const response = await fetch(
          "https://advenwarecareerlink.com/acl/Organizations/Regester_organization.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message);
        }

        if(result.message == 'available')
        {
          alert(`Agent '${formData.name}' already exists, try adding unique numbers to your name to make it stand out`)
        }

        else{

            const login = () => {
                    Cookies.set("organization_name", `${formData.name}`, {
                      expires: 7 * 42
                   });
          
                  
                 };
          
                 login()

              handleNavigation('employer')

          alert("Account created successfully!");
        }

        
      

      console.log("Agent registration:", formData);

      await new Promise((resolve) =>
        setTimeout(resolve, 1200)
      );

     // alert("Agent account created successfully!");

    } catch (error) {
      console.error(error);
      alert(
        "Unable to create account. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="agent-register-page">

      {/* ==================================================
          LEFT SIDE
      ================================================== */}

      <section className="agent-register-hero">

        <div className="agent-register-background-grid"></div>

        <div className="agent-register-hero-content">

          {/* BRAND */}

          <div className="agent-register-brand">

             <img
                            src={logo}
                            alt="Advenware Career Link"
                            className="landing-logo-image"
            />

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>

          </div>


          {/* HERO CONTENT */}

          <div className="agent-register-hero-message">

            <div className="agent-register-badge">
              ORGANISATION REGISTRATION
            </div>

            <h1>
              Join.
              <span> Connect. </span>
              Make an Impact.
            </h1>

            <p>
              Create your Advenware orgainization account
              and become part of a network which makes it 
              easier for you to find the right talent.
            </p>


            {/* FEATURES */}

            <div className="agent-register-features">

              <div className="agent-register-feature">

                <div className="agent-register-feature-icon">
                  ✓
                </div>

                <div>
                  <strong>
                    Connect with right talents
                  </strong>

                  <span>
                    Discover talents to your correct specification.
                  </span>
                </div>

              </div>


              <div className="agent-register-feature">

                <div className="agent-register-feature-icon">
                  ✓
                </div>

                <div>
                  <strong>
                    Find talents
                  </strong>

                  <span>
                    Connect yourself to the right talent.
                  </span>
                </div>

              </div>


              <div className="agent-register-feature">

                <div className="agent-register-feature-icon">
                  ✓
                </div>

                <div>
                  <strong>
                    Grow your reach
                  </strong>

                  <span>
                    Manage your activities from one secure portal.
                  </span>
                </div>

              </div>

            </div>

          </div>


          <div className="agent-register-hero-footer">

            <span>
              © 2026 Advenware Careere Link
            </span>

            <span>
              Orgainization Operations • Students • Organizations
            </span>

          </div>

        </div>

      </section>


      {/* ==================================================
          RIGHT SIDE
      ================================================== */}

      <section className="agent-register-area">

        <div className="agent-register-wrapper">

          {/* MOBILE BRAND */}

          <div className="mobile-agent-register-brand">

            <div className="agent-register-brand-icon">
              AC
            </div>

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>

          </div>


          {/* HEADER */}

          <div className="agent-register-header">

            <div className="agent-register-label">
              ORGINIZATION REGISTRATION
            </div>

            <h1>
              Create your account
            </h1>

            <p>
              Register as an Advenware Partner Orgainization to
              access this portal.
            </p>

          </div>


          <form onSubmit={handleSubmit}>

            {/* FULL NAME */}

            <div className="agent-register-input-group">

              <label>
                Full name <span>*</span>
              </label>

              <div className="agent-register-input-container">

                <span className="agent-register-input-icon">
                  👤
                </span>

                <input
                  type="text"
                  name="name"
                  placeholder="Enter your orgaization name"
                  value={formData.name}
                  onChange={handleChange}
                  autoComplete="name"
                />

              </div>

              {errors.name && (
                <small className="agent-register-error">
                  {errors.name}
                </small>
              )}

            </div>


            {/* EMAIL */}

            <div className="agent-register-input-group">

              <label>
                Email address <span>*</span>
              </label>

              <div className="agent-register-input-container">

                <span className="agent-register-input-icon">
                  @
                </span>

                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                />

              </div>

              {errors.email && (
                <small className="agent-register-error">
                  {errors.email}
                </small>
              )}

            </div>


            {/* PASSWORD */}

            <div className="agent-register-input-group">

              <label>
                Password <span>*</span>
              </label>

              <div className="agent-register-input-container">

                <span className="agent-register-input-icon">
                  🔒
                </span>

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  name="password"
                  placeholder="Create a password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="new-password"
                />

                <button
                  type="button"
                  className="agent-register-password-toggle"
                  onClick={() =>
                    setShowPassword(
                      (prev) => !prev
                    )
                  }
                >
                  {showPassword ? "Hide" : "Show"}
                </button>

              </div>

              {errors.password && (
                <small className="agent-register-error">
                  {errors.password}
                </small>
              )}

            </div>


            {/* CONFIRM PASSWORD */}

            <div className="agent-register-input-group">

              <label>
                Confirm password <span>*</span>
              </label>

              <div className="agent-register-input-container">

                <span className="agent-register-input-icon">
                  🔒
                </span>

                <input
                  type={
                    showConfirmPassword
                      ? "text"
                      : "password"
                  }
                  name="confirmPassword"
                  placeholder="Confirm your password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  autoComplete="new-password"
                />

                <button
                  type="button"
                  className="agent-register-password-toggle"
                  onClick={() =>
                    setShowConfirmPassword(
                      (prev) => !prev
                    )
                  }
                >
                  {showConfirmPassword
                    ? "Hide"
                    : "Show"}
                </button>

              </div>

              {errors.confirmPassword && (
                <small className="agent-register-error">
                  {errors.confirmPassword}
                </small>
              )}

            </div>


            {/* SECURITY CARD */}

            <div className="agent-register-security-card">

              <div className="agent-register-security-icon">
                ✓
              </div>

              <div>

                <strong>
                  Secure registration
                </strong>

                <p>
                  Your account information is protected.
                  Only authorized Advenware personnel can
                  access field agent accounts.
                </p>

              </div>

            </div>


            {/* REGISTER BUTTON */}

            <button
              type="submit"
              className="agent-register-button"
              disabled={loading}
            >

              {loading
                ? "Creating account..."
                : "Create Organization account →"}

            </button>


            {/* LOGIN */}

            <div className="agent-register-login">

              <span>
                Already have an account?
              </span>

              <button
                type="button"
                onClick={() =>
                   handleNavigation('Organization_log_in')
                }
              >
                Sign in
              </button>

            </div>


            {/* DIVIDER */}

            <div className="agent-register-divider">

              <span></span>

              <p>
                ADVENEWARE CAREERE LINK
              </p>

              <span></span>

            </div>


            <p className="agent-register-footer-note">
              Secure Orgainization registration
            </p>

          </form>

        </div>

      </section>

    </div>
  );
};

export default Create_orgainzation_account;